import { light } from '@fortawesome/fontawesome-svg-core/import.macro'
import { ExcludedPeriod } from 'pages/site/models'
import { Icon, RangeSummaryLabel } from 'src/components/ui'

type Props = {
  period: ExcludedPeriod
}

export function ExcludedPeriodLabel({ period }: Props): JSX.Element {
  if (!period) return <></>
  return (
    <div className="flex items-center gap-xs">
      <Icon icon={light('calendar-range')} />
      {period.timeRange && (
        <RangeSummaryLabel value={period.timeRange} options={[]} />
      )}
    </div>
  )
}
